import React, { useState,useRef ,useEffect} from "react";
import { Empty, Button,Checkbox} from "antd";
import { useNavigate } from "react-router-dom";

import "./timeSheetTable.scss";
import { getFieldStyle } from "../../themes.js";
import useTeamTimeSheetStore from "../../store/teamtimesheet.js";
const format = 'HH:mm';

export default function MyTimeSheetTable({
    isClickable = false,
    titleList,
    data,
    config,
    currentView,
    extraData 
}) {
    const navigate = useNavigate();
    const [selectAll, setSelectAll] = useState(false);
    const { updateLeaveApplicationStatus } = useTeamTimeSheetStore();

    const checkBoxArray=data?.map((ele)=>{
        return {
            type:"",
            selected: false,
            status: ""
         }
    })
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [checkBoxData, setCheckBoxData] = useState(checkBoxArray);

    const ResetCheckBox = () => {
        var checkBoxResetArray=data?.map((ele)=>{
            return {
                type:"",
                selected: false,                          
                status: ""  }
        })
        setCheckBoxData(()=>([...checkBoxResetArray]))
    };
    useEffect(() => {  
        setCheckBoxData(checkBoxArray)
    }, []);

    if ((!data) || data?.length == 0) {
        return <Empty style={{ margin: "60px" }} />;
    }

    function enableDbUpdate (){
        for(let idx = 0; idx < checkBoxData?.length; idx++){
            //console.log("enableDbUpdate checkBoxArray", idx,checkBoxData[idx].selected)      
            if (checkBoxData[idx].selected ) {
                return true
            } 
        }
        return false
    }
    const onCheckBoxChange = (e) => {
        if (e.target.checked) {
            checkBoxData[e.target.value].selected = true; 
            //console.log("Setting checkBoxData", e.target.value,true,checkBoxData)      
        }else{
            checkBoxData[e.target.value].selected = false; 
            //console.log("Setting checkBoxData", e.target.value,false) 
        }
        if (enableDbUpdate() == true){
            setUpdateAvailable(true)

        }else{
            setUpdateAvailable(false)
        } 
        setCheckBoxData(()=>([...checkBoxData]))
      }

    const getUpdated=(rowIndex)=>{
        return checkBoxData?.[rowIndex]?.selected 
    }

    const handleSelectAll = () => {
        const tempCheckBoxData = [...checkBoxData];
        if (selectAll) {
        tempCheckBoxData.forEach((item) => {
            item.selected = false;
        });
        setCheckBoxData(tempCheckBoxData);
        setUpdateAvailable(false);
        } else {
        tempCheckBoxData.forEach((item) => {
            item.selected = true;
        });
        setCheckBoxData(tempCheckBoxData);
        setUpdateAvailable(true);
        }
        setSelectAll(!selectAll);
    };
  
    const handleClick= () =>{

    }
    const handleClickInfo = () =>{

    }
    const handleUpdates = () =>{

    }

    function getTimeNow() {
        const today = new Date();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const date = today.getDate();
        const currentDate = date + "-" + month + "-" + year;
        return currentDate;
    }        

    const encodeJson = (status) =>{
        let encodedJsonValues ={};
        //get company details
        const userData = JSON.parse(localStorage.getItem("userDetails"));
        //now fill the parameters
        let num=0
        
        encodedJsonValues.leaveinfo= []
        for(let idx = 0; idx < checkBoxData.length; idx++){
            //console.log("checkBoxData", idx,checkBoxData[idx].selected)
            if (checkBoxData[idx].selected) {
                encodedJsonValues.leaveinfo[num] = {}
                encodedJsonValues.leaveinfo[num].username = extraData[idx]?.req?.username;
                encodedJsonValues.leaveinfo[num].qhuid =extraData[idx]?.req?.qhuid;
                encodedJsonValues.leaveinfo[num].qhlid =extraData[idx]?.qhlid;           
                num++;
            } 
        }
        encodedJsonValues.status = status      
        //get the current date
        let newDate = getTimeNow()
        encodedJsonValues.updatedby= userData.qhuid;
        encodedJsonValues.updatedbyname= userData.username;
        encodedJsonValues.updatedon    = newDate;
            
        return encodedJsonValues
    }

    const handleCancelLeaves = (rowIndex) =>{
        var jasonValues= encodeJson("CANCEL_REQ") 
        console.log("Encoded data", jasonValues)
        updateLeaveApplicationStatus(jasonValues)
        ResetCheckBox();
        setUpdateAvailable(false);
        setSelectAll(false)
    }

    return (
        <div className="timeSheetTable-wrapper">
            <div className="timeSheetTable-btn-wrapper"  >
                {
                    currentView=="daily"?
                    <>
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleUpdates}
                        >
                        CheckIN
                        </Button> 
                        <Button
                            className="timeSheetTable-btn"
                            disabled={!updateAvailable}
                            onClick={handleUpdates}
                        >
                        CheckOut
                        </Button>                     
                    </>
                    :<></>
                }
   
                <Button
                    className="timeSheetTable-btn"
                    disabled={!updateAvailable}
                    onClick={handleUpdates}
                >
                  Add Comments
                </Button>                              
            </div>            
            <div
                className="table-title-wrapper"
                style={{
                    gridTemplateColumns: config
                }}
            >
                {titleList.map((title) => (
                    <div className="table-title">
                        {title === "Select" ? (
                        <Checkbox
                            className="table-title-checkbox"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleSelectAll()}
                            checked={selectAll}
                        ></Checkbox>
                        ) : (
                        <p className="table-title-text">{title}</p>
                        )}
                    </div>
                ))}
            </div>
            {data?.map((table, rowIndex) => (
                <div
                    onClick={handleClick(table.jobId || table.jd_id)}
                    key={table.id}
                    className="table-info-wrapper"
                    style={{
                        gridTemplateColumns: config,
                        cursor: isClickable && "pointer",
                    }}
                >
                    {Object.keys(table)?.map((tableInfo, idx) => (
                        <div className="table-info"
                             style={{
                                ...getFieldStyle(tableInfo, table[tableInfo]),
                             }}
                             onClick={()=> (tableInfo == "history")?handleClickInfo(table.id, table.qhid):"" }   
                        >
                            {tableInfo === "select" ? (
                                <Checkbox
                                className="checkbox-wrapper"
                                value={rowIndex}
                                onChange={onCheckBoxChange}
                                checked={getUpdated(rowIndex)}
                                ></Checkbox>
                            ) : (
                                <></>
                            )}                                
                            { tableInfo === "actions" ? (
                                <>
                                    {
                                        <Button
                                            className="timeSheetTable-btn"
                                            disabled={getUpdated(rowIndex)?false:true}
                                            onClick={handleCancelLeaves}
                                            type="primary"
                                            htmlType="submit"                                           
                                        >
                                          CANCEL
                                        </Button> 
                                    }  
                                </> 
                                ):                                             
                                <>{table[tableInfo]}</> 
                            }                                
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
